import React from "react";
function Card(props) {
  const { image, name, specialty } = props;

  return (
    <div className="CommunityCard">
      <div className="Badge">
        <img src="./img/marker/liston-medalla.svg" alt="" />
      </div>
      <div className="CardDetail">
        <div className="ImgProfile">
          <img src={image} alt="" />
        </div>
        <div className="InfoCard">
          <p>{name}</p>
          <p>{specialty}</p>
        </div>
        <div className="Stars">
          <img className="Star" src="./img/Landing/community/star.svg" alt="" />
          <img className="Star" src="./img/Landing/community/star.svg" alt="" />
          <img className="Star" src="./img/Landing/community/star.svg" alt="" />
          <img className="Star" src="./img/Landing/community/star.svg" alt="" />
          <img className="Star" src="./img/Landing/community/inactive-star.svg" alt="" />
        </div>
        <div className="ProfileLink">
          <a href="#">Ver perfil</a>
        </div>
      </div>
    </div>
  );
}

export default Card;
